import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'

import { assessmentsApi } from '../../_augmentt/services/assessments'
import { customerCollectionsApi } from '../../_augmentt/services/customerCollections'
import { productFeedbackApi } from '../../_augmentt/services/productFeedback'
import { customerGraphResourcesApi } from '../../_augmentt/services/customerGraphResources'
import { featureFlagsApi } from '../../_augmentt/services/featureFlags'
import { hubApi } from '../../_augmentt/services/hub'
import { intuneAppPoliciesApi } from '../../_augmentt/services/intuneAppPolicies'
import { intunePolicyTimelinesApi } from '../../_augmentt/services/intunePolicyTimelines'
import { intuneScriptsApi } from '../../_augmentt/services/intuneScripts'
import { intuneMobileAppConfigurationsApi } from '../../_augmentt/services/intuneMobileAppConfigurations'
import { intuneAndroidAppConfigurationSchemasApi } from '../../_augmentt/services/intuneAndroidAppConfigurationSchemas'
import { intuneMobileAppsApi } from '../../_augmentt/services/intuneMobileApps'
import { intuneDeviceHealthScriptsApi } from '../../_augmentt/services/intuneDeviceHealthScripts'
import { intuneWindowsFeaturesOnboardingApi } from '../../_augmentt/services/intuneWindowsFeaturesOnboarding'
import { namedLocationTemplatesApi } from '../../_augmentt/services/namedLocationTemplates'
import { policyTemplateGroupRequirementsApi } from '../../_augmentt/services/policyTemplateGroupRequirements'
import { policyTemplateNamedLocationRequirementsApi } from '../../_augmentt/services/policyTemplateNamedLocationRequirements'
import { policyTemplateApplicationRequirementsApi } from '../../_augmentt/services/policyTemplateApplicationRequirements'
import { policyTemplateUserRequirementsApi } from '../../_augmentt/services/policyTemplateUserRequirements'
import { policyTemplateDirectoryRoleRequirementsApi } from '../../_augmentt/services/policyTemplateDirectoryRoleRequirements'
import { policyTemplateAuthenticationContextRequirementsApi } from '../../_augmentt/services/policyTemplateAuthenticationContextRequirements'
import { policyTemplateAuthenticationStrengthRequirementsApi } from '../../_augmentt/services/policyTemplateAuthenticationStrengthRequirements'
import { policyTemplateServicePrincipalRequirementsApi } from '../../_augmentt/services/policyTemplateServicePrincipalRequirements'
import { policyTemplateCustomAuthenticationFactorRequirementsApi } from '../../_augmentt/services/policyTemplateCustomAuthenticationFactorRequirements'
import { purviewDlpApi } from '../../_augmentt/services/purviewDlp'
import { purviewDlpComplianceRuleApi } from '../../_augmentt/services/purviewDlpComplianceRule'
import { purviewRetentionApi } from '../../_augmentt/services/purviewRetention'
import { purviewRetentionLabelApi } from '../../_augmentt/services/purviewRetentionLabel'
import { purviewRetentionRuleApi } from '../../_augmentt/services/purviewRetentionRule'
import { purviewSensitiveInfoTypeApi } from '../../_augmentt/services/purviewSensitiveInfoType'
import { purviewSensitivityLabelApi } from '../../_augmentt/services/purviewSensitivityLabel'
import { secureApi } from '../../_augmentt/services/secure'
import { teamsApi } from '../../_augmentt/services/teams'
import { rootReducer } from './rootDuck'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // These should be enabled and reported issues fixed
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      featureFlagsApi.middleware,
      secureApi.middleware,
      teamsApi.middleware,
      assessmentsApi.middleware,
      customerCollectionsApi.middleware,
      productFeedbackApi.middleware,
      customerGraphResourcesApi.middleware,
      intuneAppPoliciesApi.middleware,
      intunePolicyTimelinesApi.middleware,
      intuneScriptsApi.middleware,
      intuneMobileAppConfigurationsApi.middleware,
      intuneMobileAppsApi.middleware,
      intuneAndroidAppConfigurationSchemasApi.middleware,
      intuneDeviceHealthScriptsApi.middleware,
      intuneWindowsFeaturesOnboardingApi.middleware,
      namedLocationTemplatesApi.middleware,
      policyTemplateGroupRequirementsApi.middleware,
      policyTemplateNamedLocationRequirementsApi.middleware,
      policyTemplateApplicationRequirementsApi.middleware,
      policyTemplateUserRequirementsApi.middleware,
      policyTemplateDirectoryRoleRequirementsApi.middleware,
      policyTemplateAuthenticationContextRequirementsApi.middleware,
      policyTemplateAuthenticationStrengthRequirementsApi.middleware,
      policyTemplateServicePrincipalRequirementsApi.middleware,
      policyTemplateCustomAuthenticationFactorRequirementsApi.middleware,
      purviewDlpApi.middleware,
      purviewDlpComplianceRuleApi.middleware,
      purviewRetentionApi.middleware,
      purviewRetentionLabelApi.middleware,
      purviewRetentionRuleApi.middleware,
      purviewSensitiveInfoTypeApi.middleware,
      purviewSensitivityLabelApi.middleware,
      hubApi.middleware,
    ),
})

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store)

export default store
